import React, { useEffect } from "react";
import {
  EditOutlined,
  MinusOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";

interface ContactDetailProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  contactData?: {
    email?: string;
    phone?: string;
    address?: string;
    formTitle?: string;
    location?: string;
  };
  loading?: boolean;
}

const ContactDetail: React.FC<ContactDetailProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  contactData,
  loading,
}) => {
  useEffect(() => {
    if (contactData) {
      form.setFieldsValue({
        contact: {
          email: contactData.email || "",
          phone: contactData.phone || "",
          address: contactData.address || "",
          formTitle: contactData.formTitle || "",
          location: contactData.location || "",
        },
      });
    } else {
      form.resetFields();
    }
  }, [contactData, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-x-auto hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Email</th>
                  <th className="py-3 px-4 text-left">Phone</th>
                  <th className="py-3 px-4 text-left">Address</th>
                  <th className="py-3 px-4 text-left">Form Title</th>
                  <th className="py-3 px-4 text-left">Location</th>
                  <th className="py-3 px-4 text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                {contactData ? (
                  <tr className="bg-[#F9F9F9] border-b">
                    <td className="py-3 px-4">{contactData.email || "—"}</td>
                    <td className="py-3 px-4">{contactData.phone || "—"}</td>
                    <td className="py-3 px-4">{contactData.address || "—"}</td>
                    <td className="py-3 px-4">
                      {contactData.formTitle || "—"}
                    </td>
                    <td className="py-3 px-4">
                      {contactData.location ? (
                        <iframe
                          src={contactData.location}
                          width="200"
                          height="250"
                          allowFullScreen
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          className="rounded-lg"
                        />
                      ) : (
                        "—"
                      )}
                    </td>
                    <td className="py-3 px-4 text-end">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px] text-primary hover:text-blue-600"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Contact Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden">
            {contactData ? (
              <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-2">
                <p>
                  <strong>Email:</strong> {contactData.email || "—"}
                </p>
                <p>
                  <strong>Phone:</strong> {contactData.phone || "—"}
                </p>
                <p>
                  <strong>Address:</strong> {contactData.address || "—"}
                </p>
                <p>
                  <strong>Form Title:</strong> {contactData.formTitle || "—"}
                </p>
                <strong>Location:</strong>{" "}
                {contactData.location ? (
                  <iframe
                    src={contactData.location}
                    width="100%"
                    height="200"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded-lg"
                  />
                ) : (
                  "—"
                )}
                <div>
                  <span className="font-semibold text-primary block mt-2 mb-1">
                    Action:
                  </span>
                  <EditOutlined
                    onClick={() => setIsEditing(true)}
                    className="cursor-pointer text-black text-[18px]"
                  />
                </div>
              </div>
            ) : (
              <div className="flex justify-center p-4">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Contact Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-6 rounded-lg shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Email"
                name={["contact", "email"]}
                rules={[{ required: true, message: "Please enter email" }]}
              >
                <Input placeholder="Enter email" />
              </Form.Item>

              <Form.Item
                label="Phone"
                name={["contact", "phone"]}
                rules={[{ required: true, message: "Please enter phone" }]}
              >
                <Input placeholder="Enter phone" />
              </Form.Item>

              <Form.Item
                label="Address"
                name={["contact", "address"]}
                rules={[{ required: true, message: "Please enter address" }]}
              >
                <Input placeholder="Enter address" />
              </Form.Item>

              <Form.Item
                label="Form Title"
                name={["contact", "formTitle"]}
                rules={[{ required: true, message: "Please enter form title" }]}
              >
                <Input placeholder="Enter form title" />
              </Form.Item>

              <Form.Item
                label="Google Map's Location"
                name={["contact", "location"]}
                rules={[{ required: true, message: "Please enter form title" }]}
              >
                <Input placeholder="Enter google maps location..." />
              </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-6">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactDetail;
